import { useContext, useEffect, useState } from "react";
import { VarifyContext } from "../context/VarifyContext.js";
import { Navigate, useParams } from "react-router-dom";
import axios from "axios";

export const VarifyRoute = ({ children }) => {
  const { varifyCode } = useContext(VarifyContext);
  const { qrCode } = useParams();
  const [isCodeInvalid, setIsCodeInvalid] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  //const apiLink = "http://localhost:4348/api/v1";
  const apiLink = "https://xl-api.notionspromos.com/api/v1";

  useEffect(() => {
    const getVerifyCode = async () => {
      if (!qrCode) {
        setIsCodeInvalid(true);
        setIsChecking(false);
        return;
      }

      try {
        const response = await axios.get(`${apiLink}/re-check-code/${qrCode}`);

        if (!response.data) {
          // Code not found in DB => allow
          setIsCodeInvalid(false);
        } else {
          const flavorList = response.data.selectflavor;

          if (Array.isArray(flavorList) && flavorList.length === 0) {
            // Valid: code found and not used
            setIsCodeInvalid(false);
          } else {
            // Invalid: code found and used
            setIsCodeInvalid(true);
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // API returns 404 when code is not in DB => treat as valid
          setIsCodeInvalid(false);
        } else {
          console.error("API error:", error);
          setIsCodeInvalid(true); // Other errors => block
        }
      } finally {
        setIsChecking(false);
      }
    };

    getVerifyCode();
  }, [qrCode]);

  if (isChecking) {
    return <div className="loading_wrp">Verifying...</div>;
  }

  if (!varifyCode || isCodeInvalid) {
    return <Navigate to="/" />;
  }

  return children;
};
